import axios from "axios";
import {
  CREATE_TRANSIT_FORM,
  TRANSIT_APPROVE,
  TRANSIT_DETAILS,
  TRANSIT_HISTORY,
  TRANSIT_LIST,
  UPLOAD_PDF_TRANSIT,
  WITHDRAW_TRANSIT,
} from "../api";
import axiosInstance from "../axiosInstance";

export const creatTransit = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_TRANSIT_FORM, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};


export const uploadTransitPdf=(props)=>onResponse=>{
  console.log(props,"uploadprops");
  
  try{
    axiosInstance.post(UPLOAD_PDF_TRANSIT,props)
    .then((response)=>{
      onResponse(response?.data)
    })
    .catch((err)=>{
      onResponse(err?.response?.data)
    })
  }catch(err){
    console.log(err);
    
  }
}

export const withdrawPdf=(props)=>onResponse=>{
  try{
    axiosInstance.put(WITHDRAW_TRANSIT,props)
    .then((response)=>{
      onResponse(response?.data)
    })
    .catch((err)=>{
      onResponse(err?.response?.data)
    })
  }catch(err){
    console.log(err);
    
  }
}

export const transitListFetch = (props) => (onResponse) => {
  try {
    let BASE_URL = TRANSIT_LIST + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
     if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.museum) {
      BASE_URL += "museum=" + props.museum + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const singleTransitDetails = (props) => (onResponse) => {
  try {
    let BASE_URL = TRANSIT_DETAILS + "?";
    if (props?.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props?.id) {
      BASE_URL += "id=" + props.id + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const transitApprove = (props) => (onResponse) => {
  try {
    axiosInstance
      .put(TRANSIT_APPROVE, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  } catch (err) {}
};

export const transitHistoryFetch=(props)=>onResponse=>{
  try {
    let BASE_URL = TRANSIT_HISTORY + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.museum_object) {
      BASE_URL += "museum_object=" + props.museum_object  + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }
    if (props.start_date) {
      BASE_URL += "start_date=" + props.start_date + "&";
    }
    if (props.end_date) {
      BASE_URL += "end_date=" + props.end_date + "&";
    }
    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((err) => {
        onResponse(err?.response?.data);
      });
  }catch(err){

  }
}
